import service from '@/plugin/axios/index.js';
import Axios from 'axios';
import publicService from '@/plugin/axios/public.js';
import publicRequest from '@/plugin/axios/request-public.js';

const uuid = require('uuid');

Axios.defaults.timeout = 5000; // 请求超时
if (process.env.NODE_ENV === 'production') {
  Axios.defaults.baseURL = '../vas-web/';
}
// eslint-disable-next-line no-extend-native
Date.prototype.Format = function(fmt) {
  const o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      `${this.getFullYear()}`.substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
    }
  }
  return fmt;
};
const defaults = {
  data: '',
  sign: '',
  requestId: uuid(),
  requestTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),
  version: process.env.VUE_APP_VERSION
};
// config.headers['appType'] = 1
// export const login = (data) => Axios({
//   url: '/public/common/user/login',
//   method: 'post',
//   headers: { appType: 1, 'content-type': 'application/json;charset=UTF-8'},
//   withCredentials: true,
//   data,
// });
// export const logOut = (data) => Axios({
//   url: '/common/user/logout',
//   method: 'post',
//   data,
// });
// export const getProductTypes = data => Axios({
//   url: '/h5/channel/right/productTypes',
// headers: {
//   'Content-Type': 'application/json;charset=UTF-8'
// },
//   method: 'post',
//   data,
// });
// export const loginByPhone = async (data) => Axios({
//   baseURL: process.env.NODE_ENV == 'production'?'../vas-web/':'/api',
//   url: '/public/wxapp/client/loginByPhone',
//   method: 'post',
//   headers: { appType: 1, 'content-type': 'application/json;charset=UTF-8', 'Accept-Language': 'zh-CN' },
//   withCredentials: true,
//   data: {
//     ...defaults,
//     ...{
//       data: JSON.stringify(data),
//     },
//   },
// });
// export const getKey = async (data) => Axios({
//   url: '/common/key/get',
//   method: 'post',
//   headers: { appType: 1, 'content-type': 'application/json;charset=UTF-8', 'Accept-Language': 'zh-CN' },
//   withCredentials: true,
//   data: {
//     ...defaults,
//     ...{
//       data: JSON.stringify(data),
//     },
//   },
// });
// export const getRigtList = (data) => service({
//   url: '/wxapp/client/right/list',
//   method: 'post',
//   data
// });
// export const saveByCarNo = (data) => service({
//   url: '/wxapp/car/saveByCarNo',
//   method: 'post',
//   data
// });
// export const orderSubmit = (data) => service({
//   url: '/wxapp/rescue/order/submit',
//   method: 'post',
//   data
// });
// export const estimate = (data) => service({
//   url: '/wxapp/order/fee/estimate',
//   method: 'post',
//   data
// });
// export const getWxCode = (data) => service({
//   url: '/public/common/wxapp/qrCode/orderDetail/get',
//   method: 'post',
//   data
// });

export const rescueDetail = (data) =>
  publicRequest({
    url: '/vas/public/h5/detail',
    method: 'post',
    data
  });

export const rescueFeeEstimate = (data) =>
  publicRequest({
    url: '/vas/public/h5/fee/estimate',
    method: 'post',
    data
  });

export const rescuePayPre = (data) =>
  publicRequest({
    url: '/vas/public/h5/pay/pre',
    method: 'post',
    data
  });

export const rescuePayCheck = (data) =>
  publicRequest({
    url: '/vas/public/h5/queryOrderStatus',
    method: 'post',
    data
  });

export const rescueOrderCurrentData = (data) =>
  publicRequest({
    url: '/vas/public/h5/order/current/data',
    method: 'post',
    data
  });

// export const rescuePayZero = (data) => service({
//   url: '/public/h5/rescue/pay/zero',
//   method: 'post',
//   data
// });

// test wxpay
// export const getWxPay = (data) => service({
//   url: '/wxapp/pay/h5/test',
//   method: 'post',
//   data
// });

// 中银验证码接口
export const phonePin = async(data) =>
  Axios({
    baseURL: process.env.NODE_ENV === 'production' ? '../vas-web/' : '/api',
    url: '/public/h5/login/phonePin',
    method: 'post',
    headers: {
      appType: 2,
      'content-type': 'application/json;charset=UTF-8',
      'Accept-Language': 'zh-CN'
    },
    withCredentials: true,
    data: {
      ...defaults,
      ...{
        data: JSON.stringify(data)
      }
    }
  });

// 中银手机号验证码登陆
// export const loginOn = async (data) => Axios({
//   baseURL: process.env.NODE_ENV == 'production'?'../vas-web/':'/api',
//   url: '/public/h5/login/loginByPhone',
//   method: 'post',
//   headers: { appType: 2, 'content-type': 'application/json;charset=UTF-8', 'Accept-Language': 'zh-CN' },
//   withCredentials: true,
//   data: {
//     ...defaults,
//     ...{
//       data: JSON.stringify(data),
//     },
//   },
// });

export const loginOn = (data) =>
  publicRequest({
    url: '/public/h5/login/loginByPhone',
    method: 'post',
    data
  });

// 查看用户绑定车辆
export const userCar = (data) =>
  publicRequest({
    url: '/vasPartner/h5/car/list',
    method: 'post',
    data
  });

// 用户新增车辆
export const insertCar = (data, noError) =>
  publicRequest({
    url: '/vasPartner/h5/car/save',
    method: 'post',
    noError: noError,
    data
  });

// H5页面ocr识别行驶证
export const ocrVehicleLicense = (data) =>
  publicRequest({
    url: '/vas/h5/default/order/car/ocr',
    method: 'post',
    data
  });

// 中银权益查询接口
export const interestsRight = (data) =>
  publicRequest({
    url: '/vas/h5/use/channel/findValidRight',
    method: 'post',
    data
  });

// 中银洗车优惠查询接口
export const getActiveLink = (data) =>
  publicRequest({
    url: '/vas/h5/default/order/boci/getActiveLink',
    method: 'post',
    data
  });

// 获取微信jsapi_ticket
export const jsapiTicket = (data) =>
  publicRequest({
    url: '/vas/h5/wxapp/jsapiTicket',
    method: 'post',
    data
  });

// 查询订单实时数据
export const orderCurrentData = (data) =>
  publicRequest({
    url: '/vas/h5/default/order/current/data',
    method: 'post',
    data
  });

// 获取公共微信jsapi_ticket
export const publicJsapiTicket = (data) =>
  publicService({
    url: '/public/h5/wxapp/jsapiTicket',
    method: 'post',
    data
  });

// token是否失效
export const checkToken = (data) =>
  service({
    url: '/public/h5/login/checkToken',
    method: 'post',
    data
  });

// 安全检测详情
export const safetyInspectOrderDetail = (data) =>
  service({
    url: '/h5/safetyInspection/order/detail',
    method: 'post',
    data
  });

// 代驾详情
export const drivingOrderDetail = (data) =>
  service({
    url: '/h5/driving/order/detail',
    method: 'post',
    data
  });

// 救援详情
export const rescueOrderDetail = (data) =>
  service({
    url: '/h5/rescue/order/detail',
    method: 'post',
    data
  });

// 年检详情
export const inspectOrderDetail = (data) =>
  service({
    url: '/h5/annual/inspection/order/detail',
    method: 'post',
    data
  });

// 渠道商免登录接口
// export const loginByChannelToken = async (data) => Axios({
//   baseURL: process.env.NODE_ENV == 'production'?'../vas-web/':'/api',
//   url: '/vasCommon/public/h5/loginByChannelToken',
//   method: 'post',
//   headers: { appType: 1, 'content-type': 'application/json;charset=UTF-8', 'Accept-Language': 'zh-CN' },
//   withCredentials: true,
//   data: {
//     ...defaults,
//     ...{
//       data: JSON.stringify(data),
//     },
//   },
// });

// 校验用户中心旧token
export const loginByChannelToken = (data) =>
  publicRequest({
    url: '/vasCommon/public/h5/loginByChannelToken',
    method: 'post',
    data
  });

// 订单详情
export const orderDetail = (data) =>
  publicRequest({
    url: '/vas/h5/default/order/detail',
    method: 'post',
    data
  });

// 客户自解查询任务详情
export const selfSolveTaskDetail = (data) =>
  publicRequest({
    url: '/vas/public/h5/selfSolve/taskDetail',
    method: 'post',
    data
  });

// 客户自解订单影像模板
export const selfSolveMediaTemplate = (data) =>
  publicRequest({
    url: '/vas/public/h5/selfSolve/mediaTemplate',
    method: 'post',
    data
  });

// 客户自解订单获取影像详情
export const selfSolveMediaDetail = (data) =>
  publicRequest({
    url: '/vas/public/h5/selfSolve/getMediaDetail',
    method: 'post',
    data
  });

// 客户自解订单保存影像
export const selfSolveSaveMedia = (data) =>
  publicRequest({
    url: '/vas/public/h5/selfSolve/saveMedia',
    method: 'post',
    data
  });

// 客户自解订单删除影像
export const selfSolveDelMedia = (data) =>
  publicRequest({
    url: '/vas/public/h5/selfSolve/delMediaById',
    method: 'post',
    data
  });

// 客户自解提交审核
export const selfSolveAudit = (data) =>
  publicRequest({
    url: '/vas/public/h5/selfSolve/audit',
    method: 'post',
    data
  });

// 订单取消
export const cancelOrder = (data) =>
  publicRequest({
    url: '/vas/h5/default/order/cancel',
    method: 'post',
    data
  });

// 字典批量查询
export const commonDictQueryList = (data) =>
  publicRequest({
    url: '/vasCommon/h5/common/dict/query',
    method: 'post',
    data
  });

// 安全检测门店地区表（二层结构）
export const safetyInspectionStoreareas = (data) =>
  publicRequest({
    url: '/vasPartner/h5/store/areas',
    method: 'post',
    data
  });

// h5安全检测门店列表
export const safetyInspectionStores = (data) =>
  publicRequest({
    url: '/vasPartner/h5/store/page',
    method: 'post',
    data
  });

// 根据案件号查订单id
export const getOrderDetailByCaseNo = (data) =>
  publicRequest({
    url: '/vas/h5/default/order/detailByCaseNo',
    method: 'post',
    data
  });

// 用户告知函
export const getNeedTellCustomer = () =>
  publicRequest({
    url: '/vasCommon/h5/common/dict/query',
    method: 'post',
    data: {
      code: 'NEED_TELL_CUSTOMER'
    }
  });

// 礼品卡充值预支付
export const giftRechargePre = (data) =>
  service({
    url: '/h5/',
    method: 'post',
    data
  });
// 查询车辆详情
export const userCarDetail = (data) =>
  publicRequest({
    url: '/vasPartner/h5/car/detail',
    method: 'post',
    data
  });

// 解绑车辆
export const userCarUntied = (data) =>
  publicRequest({
    url: '/vasPartner/h5/car/delete',
    method: 'post',
    data
  });

// -----------------车生活-------------//
// 验证码登录
export const getCode = (data) =>
  publicRequest({
    url: '/vasCommon/public/h5/getCode',
    method: 'post',
    data
  });

// 验证码登录
export const codeLogin = (data) =>
  publicRequest({
    url: '/vasCommon/public/h5/loginByCode',
    method: 'post',
    data
  });

// 校验H5token
export const vasCommonCheckToken = (data) =>
  publicRequest({
    url: '/vasCommon/public/h5/checkToken',
    method: 'post',
    data
  });

// 获取充值产品
export const getRechargeProductInfo = (data) =>
  publicRequest({
    url: '/vas/h5/product/getRechargeProductInfo',
    method: 'post',
    data
  });

// 获取手机归属地
export const phoneMoblieAttribution = (data) =>
  publicRequest({
    url: '/vas/h5/third/phone/attribution',
    method: 'post',
    data
  });

// 权益权益接口
export const findValidRight = (data) =>
  publicRequest({
    url: '/vas/h5/use/findValidRight',
    method: 'post',
    data
  });

// 创建订单接口
export const carLifeOrderCreate = (data) =>
  publicRequest({
    url: '/vas/h5/order/create',
    method: 'post',
    data
  });

// h5费用预支付
export const carLifePayPre = (data) =>
  publicRequest({
    url: '/vas/h5/pay/pre',
    method: 'post',
    data
  });

// h5订单列表接口
export const carLifeOrderList = (data) =>
  publicRequest({
    url: '/vas/h5/order/list',
    method: 'post',
    data
  });

// h5订单详情接口
export const carLifeOrderDetail = (data) =>
  publicRequest({
    url: '/vas/h5/order/detail',
    method: 'post',
    data
  });

// 取消订单接口
export const carLifeOrderCancel = (data) =>
  publicRequest({
    url: '/vas/h5/order/cancel',
    method: 'post',
    data
  });

// 校验用户中心旧token
export const checkOldToken = (data) =>
  publicRequest({
    url: '/vasCommon/public/checkOldToken',
    method: 'post',
    data
  });

// 字典
export const queryDict = (data) =>
  publicRequest({
    url: '/vasCommon/h5/common/dict/query',
    method: 'post',
    data
  });

// 门店列表接口
export const getStoreList = (data) =>
  publicRequest({
    url: '/vas/h5/store/list',
    method: 'post',
    data
  });

// 门店详情接口
export const getStoreDetailUrl = (data) =>
  publicRequest({
    url: '/vas/h5/store/detail/url',
    method: 'post',
    data
  });

// 一键加油付款记录接口
export const getPayRecordList = (data) =>
  publicRequest({
    url: '/vas/h5/order/payRecordList',
    method: 'post',
    data
  });

export const saveSurveyReport = (data) =>
  publicRequest({
    url: '/vas/h5/operate/saveRiskSurveryTask',
    method: 'post',
    data
  });

export const getAreaTree = (data) =>
  publicRequest({
    url: '/vasCommon/h5/common/area/getTree',
    method: 'post',
    data
  });

// 获取阿里云配置信息
export const getOssToken = (data) =>
  publicRequest({
    url: '/vasCommon/h5/common/file/getSts',
    method: 'post',
    data
  });

// 装修贷查勘报告详情
export const riskSurveryTaskDetail = (data) =>
  publicRequest({
    url: '/vas/h5/operate/riskSurveryTaskDetail',
    method: 'post',
    data
  });

export const carLifeCategory = (data) =>
  publicRequest({
    url: '/vas/h5/category/getCarLifeCategoryList',
    method: 'post',
    data
  });

// 查询违章车辆
export const carList = (data) =>
  publicRequest({
    url: '/vasPartner/h5/violation/car/list',
    method: 'post',
    data
  });

// 保存/修改违章车辆
export const saveCar = (data) =>
  publicRequest({
    url: '/vasPartner/h5/violation/car/save',
    method: 'post',
    data
  });

// 删除违章车辆
export const deleteCar = (data) =>
  publicRequest({
    url: '/vasPartner/h5/violation/car/delete',
    method: 'post',
    data
  });

// 违章支持城市查询
export const getCity = (data) =>
  publicRequest({
    url: '/vas/h5/third/violation/city',
    method: 'post',
    data
  });

// 违章信息查询
export const getCarInfo = (data) =>
  publicRequest({
    url: '/vas/h5/third/violation/info',
    method: 'post',
    data
  });

// 根据code查询字典树结构  违章代办常见问题
export const getQueryTree = (data) =>
  publicRequest({
    url: '/vasCommon/h5/common/dict/queryTree',
    method: 'post',
    data
  });

// 违章代办订单列表
export const getOrderList = (data) =>
  publicRequest({
    url: '/vas/h5/order/list',
    method: 'post',
    data
  });

// 罚单缴费信息查询
export const getTicketPayment = (data) =>
  publicRequest({
    url: '/vas/h5/third/ticket/payment',
    method: 'post',
    data
  });

// 创建订单接口
export const createOrder = (data) =>
  publicRequest({
    url: '/vas/h5/order/create',
    method: 'post',
    data
  });

// 查询产品列表
export const findProductList = (data) =>
  publicRequest({
    url: '/vas/h5/product/findProductList',
    method: 'post',
    data
  });

// 查询产品列表
export const findProductListByName = (data) =>
  publicRequest({
    url: '/vas/h5/product/findProductListByName',
    method: 'post',
    data
  });

// 查询产品详情
export const getAllSimpleProductInfo = (data) =>
  publicRequest({
    url: '/vas/h5/product/getAllSimpleProductInfo',
    method: 'post',
    data
  });

// 违章缴费信息查询
export const getThirdPayment = (data) =>
  publicRequest({
    url: '/vas/h5/third/violation/payment',
    method: 'post',
    data
  });

// 识别行驶证接口
export const getCarOcr = (data) =>
  publicRequest({
    url: '/vas/h5/car/ocr/vehicleLicense',
    method: 'post',
    data
  });

// 查询产品规格
export const getSpecsListByProductCode = (data) =>
  publicRequest({
    url: '/vas/h5/specs/product/getSpecsListByProductCode',
    method: 'post',
    data
  });

// 获取真实卡密信息
export const getCardInfo = (data) =>
  publicRequest({
    url: '/vas/h5/order/card/info',
    method: 'post',
    data
  });

// 查询礼品卡/视听卡库存
export const getThirdCardInfo = (data) =>
  publicRequest({
    url: '/vas/h5/third/card/info',
    method: 'post',
    data
  });

// 查询可用卡列表
export const getCardList = (data) =>
  publicRequest({
    url: '/vasPartner/h5/customer/card/getCards',
    method: 'post',
    data
  });

// 新增卡片
export const addCard = (data) =>
  publicRequest({
    url: '/vasPartner/h5/customer/card/addCard',
    method: 'post',
    data
  });

// 删除卡片
export const delCard = (data) =>
  publicRequest({
    url: '/vasPartner/h5/customer/card/delCard',
    method: 'post',
    data
  });

// 免登陆注入token
export const loginNoToken = (data) =>
  publicRequest({
    url: '/vasCommon/public/h5/loginByChannelToken',
    method: 'post',
    data
  });

// 字典批量查询
export const queryDictByCodes = (data) =>
  publicRequest({
    url: '/vasCommon/h5/common/dict/queryByCodes',
    method: 'post',
    data
  });
//  --------------事故救援-------------
// 订单列表
export const orderList = (data) =>
  publicRequest({
    url: '/vas/channel/order/wxapp/list',
    method: 'post',
    data
  });
// 订单详情
export const getOrderDetail = (data) =>
  publicRequest({
    url: '/vas/h5/channel/order/detail',
    method: 'post',
    data
  });
// 照片
export const orderMediaInfo = (data) =>
  publicRequest({
    url: '/vas/h5/common/orderMediaInfo',
    method: 'post',
    data
  });
// 日志
export const getOrderRoute = (data) =>
  publicRequest({
    url: '/vas/h5/common/route',
    method: 'post',
    data
  });
// 权益
export const getFindValidRight = (data) =>
  publicRequest({
    url: '/vas/channel/use/findValidRight',
    method: 'post',
    data
  });
// 服务类型
export const getProductListByCategoryCode = (data) =>
  publicRequest({
    url: '/vas/channel/product/getProductListByCategoryCode',
    method: 'post',
    data
  });
// 登录验证码
export const getCodePc = (data) =>
  publicRequest({
    url: '/vasCommon/public/pc/getCode',
    method: 'post',
    data
  });
// 查询登录用户绑定的公司
export const employeeCompany = (data) =>
  publicRequest({
    url: '/vasCommon/h5/common/pc/employeeCompany',
    method: 'post',
    data
  });
// 登录
export const login = (data) =>
  publicRequest({
    url: '/vasCommon/public/pc/login/code',
    method: 'post',
    data
  });
// 新建订单
export const ordeCreate = (data) =>
  publicRequest({
    url: '/vas/channel/order/create',
    method: 'post',
    data
  });

export const switchCompany = (data) =>
  publicRequest({
    url: '/vasCommon/h5/common/pc/switchCompany',
    method: 'post',
    data
  });

// 收集个人信息记录
export const userInfoCollection = (data) =>
  publicRequest({
    url: '/vasPartner/h5/userInfoCollection/get',
    method: 'post',
    data
  });

// ************ 充电服务 ************
// 个人账户信息
export const queryChargeInfo = (data) =>
  publicRequest({
    url: '/vas/h5/customerCharge/info',
    method: 'post',
    data
  });

// 修改统计信息
export const wxappOrderAddCount = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/addCount',
    method: 'post',
    data
  });

// 查询用户已经购买的权益卡
export const findPurchasedRightCard = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/findPurchasedRight',
    method: 'post',
    data
  });

// 查询用户已经购买的权益券
export const findPurchasedRight = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/findPurchasedRightCard',
    method: 'post',
    data
  });

// 我的拉新列表
export const queryMyInvite = (data) =>
  publicRequest({
    url: '/vas/h5/right/chargeCoupon/myInvite',
    method: 'post',
    data
  });

// 我的积分列表
export const queryMyScore = (data) =>
  publicRequest({
    url: '/vas/h5/customerCharge/queryScoreDeatil',
    method: 'post',
    data
  });

// 可选充电券列表
export const queryChargeCouponList = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/couponList',
    method: 'post',
    data
  });

// 取消充电券订单
export const cancelChargeCouponOrder = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/cancel',
    method: 'post',
    data
  });

// 充电券下单
export const createChargeCouponOrder = (data, noError = false) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/create',
    method: 'post',
    noError: noError,
    data
  });

// 充电券订单详情
export const queryChargeCouponDetail = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/detail',
    method: 'post',
    data
  });

// 充电券订单预支付
export const prePayChargeCouponOrder = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/prePay',
    method: 'post',
    data
  });

// 待支付订单
export const queryUnPaidChargeCouponOrder = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/unPaid',
    method: 'post',
    data
  });

// 充电服务账户信息查询
export const queryAccountInformation = (data) =>
  publicRequest({
    url: '/vas/h5/customerCharge/chargingService/accountInformationQuery',
    method: 'post',
    data
  });

// 充电服务账户信息保存
export const saveAccountInformation = (data) =>
  publicRequest({
    url: '/vas/h5/customerCharge/chargingService/accountInformationSave',
    method: 'post',
    data
  });

// 我的钱包
export const chargeCouponMyEarn = (data) =>
  publicRequest({
    url: '/vas/h5/right/chargeCoupon/myEarn',
    method: 'post',
    data
  });

// 获取加密用户ID
export const generateCryId = (data) =>
  publicRequest({
    url: '/vas/manage/chargeCoupon/generateCryId',
    method: 'post',
    data
  });

// 获取分享二维码
export const generateQRCode = (data) =>
  publicRequest({
    url: '/vas/h5/right/chargeCoupon/generateQRCode',
    method: 'post',
    data
  });

// 查询用户剩余积分
export const queryCustomerScore = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/customerScore',
    method: 'post',
    data
  });

// 我的订单
export const queryMyOrder = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/myOrderList',
    method: 'post',
    data
  });

// 查询特惠包购买渠道
export const querySpecialRote = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/querySpecialRote',
    method: 'post',
    data
  });

// 查询虾米车服特惠包列表
export const queryDcjcSpecialList = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/queryDcjcSpecialList',
    method: 'post',
    data
  });

// 查询代理商特惠包列表
export const querySpecialList = (data) =>
  publicRequest({
    url: '/vas/h5/order/chargeCoupon/agency/querySpecialList',
    method: 'post',
    data
  });

  // 新增平安用户接口-牙齿的
export const channelUserCreateDental = (data) => publicRequest({
  url: '/vasPartner/public/h5/channel/user/createDental',
  method: 'post',
  data
});

// 新增平安用户接口-眼科
export const channelUserCreateOphthalmic = (data) => publicRequest({
  url: '/vasPartner/public/h5/channel/user/createOphthalmic',
  method: 'post',
  data
});
// 根据平安授权码获取用hopenId
export const channelGetHOpenId = (data) => publicRequest({
  url: '/vasPartner/public/h5/channel/getHOpenId',
  method: 'post',
  data
});

// 获取用户信息
export const channelUserGet = (data) => publicRequest({
  url: '/vasPartner/public/h5/channel/user/get',
  method: 'post',
  data
});

// 修改平安用户接口-齿科
export const channelUserUpdateDentalc = (data) => publicRequest({
  url: '/vasPartner/public/h5/channel/user/updateDental',
  method: 'post',
  data
});

// 修改平安用户接口-眼科
export const channelUserUpdateOphthalmic = (data) => publicRequest({
  url: '/vasPartner/public/h5/channel/user/updateOphthalmic',
  method: 'post',
  data
});

// 平安发送验证码的
export const paicApplyUserPhonePinGet = (data) => publicRequest({
  url: '/vasCommon/paic/h5/applyUser/phonePin/get',
  method: 'post',
  data
});

// 平安获取用户列表
export const channelListByUserId = (data) => publicRequest({
  url: '/vasPartner/public/h5/channel/listByUserId',
  method: 'post',
  data
});

// 用户获取token
export const customerLogin = (data) => publicRequest({
  url: '/vasCommon/public/customer/h5/login',
  method: 'post',
  data
});
